import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { PenaltyShootoutViewDto, SubmitPenaltyPickRequest, PenaltyPicksResponse } from "@/types/api";

export const penaltyApi = {
  get: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<PenaltyShootoutViewDto>("/api/penalty-shootout", { leagueId, tournamentId }),
  submit: (body: SubmitPenaltyPickRequest) => api.post<{ success: boolean }>("/api/penalty-shootout", body),
  picks: (matchId: string, { leagueId, tournamentId }: ScopedParams) =>
    api.get<PenaltyPicksResponse>(`/api/penalty-shootout/${matchId}/picks`, { leagueId, tournamentId }),
};
